module.exports = __webpack_public_path__ + "static/media/useEffect.2cb454eb.PNG";